import { getJson, postJson } from './client'

export interface UserView {
  id: string
  email: string
  displayName: string
  spoke: string
  roles: string[]
  /**
   * The password they signed in with was handed to them by an admin or an ops script. The shell sends
   * them to /account/password and keeps them there; the API refuses everything else in any case, so
   * this is a courtesy to the person, never the enforcement.
   */
  mustChangePassword: boolean
}

export interface LoginResponse {
  token: string
  expiresAt: string
  user: UserView
}

export interface PublicDeployment {
  signInIdentifier: 'email' | 'name'
}

// Port 1 on the wire. Standalone Scout serves these; attached to a hub, the hub's /api/auth/* does.
export const authApi = {
  deployment: () => getJson<PublicDeployment>('/api/deployment'),
  login: (email: string, password: string) => postJson<LoginResponse>('/api/auth/login', { email, password }),
  logout: () => postJson<void>('/api/auth/logout'),
  me: () => getJson<UserView>('/api/auth/me'),
}
